import React from 'react';
import divider from '../../assets/divider-img.png';
import image from '../../assets/cust-backtest.png';

const CustomisedBacktesting = () => {
  return (
    <div className="backtest-component">
      <div className="container">
        <div className="backtest-main-wrapper customised-sol-backtesting">
          <div className="backtest-heading-description align-c-768">
            <h2>Baktesting</h2>
            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              Before deploying any strategy in live markets, we rigorously
              backtest it using historical data. This ensures the strategy's
              viability and helps in refining its parameters for optimal
              performance.
            </p>
          </div>
          <div className="backtest-content">
            <img src={image} alt="backtest-performance" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomisedBacktesting;
